module.exports = __webpack_public_path__ + "img/fwwl_card.038b38e1.png";